// Module
var code = "<sb-app-checklist-template-editor-page></sb-app-checklist-template-editor-page> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/checklistTemplates/states/qaEditor/qa_editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;